var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('progress',{staticClass:"progress-bar",attrs:{"max":"1"},domProps:{"value":_vm.value}},[_c('span',{style:({
			width: ((_vm.value * 100) + "%")
		})},[_vm._v(" "+_vm._s(_vm.$t('progress'))+" "+_vm._s(_vm.value * 100)+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }